import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import "../dashboard/Dashboard.css";
import {
  getEmployeeSubOrdinates,
} from "../../actions/userActions/employeeAction";
import { getDoctorsWithCustomerRank } from "../../actions/userActions/doctoreWithCustomerAction";
import { getCustomerRank } from "../../actions/userActions/customerRankAction";
import Loader from "../subComponents/Loader";
import { Linechart } from "../subComponents/recharts/Linechart.jsx";
import { Barchart } from "../subComponents/recharts/Barchart.jsx";
import { StackedBarchart } from "../subComponents/recharts/StackedBarchart";
import { getPermissions } from "../../actions/userActions/permissionsAction";
import { Tabular } from "../subComponents/tabular/Tabular";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { generateReport } from "../../actions/userActions/generateReportAction";
import userService from "../../services/user.service";
import No_Data from '../../assets/images/no_data.svg'
import Heading6Regular from "../designSystem/Heading6Regular.jsx";
import CustomButton from "../subComponents/buttons/CustomButton.jsx";
import { Download, RotateCcw } from "lucide-react";
import DashboardStats from "./Stats.jsx";
import { getChartSummary } from "../../actions/ChartsAction.js";
import { getStats } from "../../actions/StatsAction.js";
import SearchInput from "../subComponents/search/SearchInput.jsx";
import DynamicTable from "../reuse_components/DynamicTable.jsx";
import CustomFilterSelect from "../designSystem/CustomFilterSelect.jsx";

function Dashboard() {
  const dispatch = useDispatch();
  const history = useHistory()
  const auth = useSelector((state) => state.auth);
  const user = JSON.parse(localStorage.getItem("user"));
  const [showKol, setShowKol] = useState(false);
  const [selected, setSelected] = useState("");
  const [page, setPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState("Call Average");
  const [callEmployee, setCallEmployee] = useState([]);
  const [callProduct, setCallProduct] = useState([]);
  const [callPracticeLocation, setCallPracticeLocation] = useState([]);
  const [callTable, setCallTable] = useState([]);
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const employeeId = user.result[0] !== undefined ? user.result[0].user.id : false;
  const chartSummaryData = useSelector((state) => state.chart);
  const chartLoading = useSelector((state) => state.chart.loading);
  const statsLoading = useSelector((state) => state.stats.loading);
  const isLoading = chartLoading || statsLoading;
  const doctors = useSelector(
    (state) => state.doctors_with_customer_reducer.doctorsWithCustomer
  );
  const generateReportPdf = useSelector((state) => state.generate_Report.report);
  const customerRank = useSelector(
    (state) => state.customer_rank_reducer.customerRank
  );
  useEffect(() => {
    dispatch(getChartSummary());
    dispatch(getStats());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDoctorsWithCustomerRank(selected))
      .then(() => {
        dispatch(getCustomerRank(-1, 10, ""));
        dispatch(getEmployeeSubOrdinates(employeeId));
        dispatch(getPermissions(employeeId));
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    if (options?.length > 0 && !selected) {
      setSelected(options[0].id);
      dispatch(getDoctorsWithCustomerRank(options[0].id));
    }
  }, [customerRank]);
  const handleClick = () => {
    dispatch(getChartSummary());
    dispatch(getStats());
    dispatch(getCustomerRank(-1, 10, ""));
    
    const idToUse = (!selected && options?.length > 0) ? options[0].id : selected;
    
    if (idToUse) {
      dispatch(getDoctorsWithCustomerRank(idToUse));
    }
  };
  const CallAverageChange = () => {
    setShowKol(false);
    setSelectedTab("Call Average");
  };
  const KolChange = () => {
    setShowKol(true);
    setSelectedTab("KOL");
  };
  const [query, setQuery] = useState("");
  const filter_doctors =
    doctors !== "isLoading"
      ? doctors.filter((doctor) => {
        return doctor.name.toLowerCase().includes(query.toLowerCase());
      })
      : [];

  if (auth.isLoggedIn === false && !user) {
    return <Redirect to="/" />;
  }
  const options =
    customerRank !== "isLoading"
      ? customerRank?.result?.map((rank) => ({
        id: rank.customerRankId,
        name: rank.rankName,
      }))
      : [];


  const handleRankChange = (event) => {
    setSelected(event.target.value);
    if (showKol !== false) {
      dispatch(getDoctorsWithCustomerRank(event.target.value));
    }
  };
  const handleSummaryClick = () => {

    const defaultPayload = {
      productCallAverageRequest: {
        productFilters: { product: 0, employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      employeeCallAverageRequest: {
        employeeFilters: { productIds: [0], employee: 0 },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      tableCallAverageRequest: {
        tableFilters: { productsIds: [0], employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      practiceLocationRequest: {
        practiceLocationFilters: { practiceLocation: 0, employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      }
    };
    const payload = {
      productCallAverageRequest: Object.keys(callProduct).length ? callProduct : defaultPayload.productCallAverageRequest,
      employeeCallAverageRequest: Object.keys(callEmployee).length ? callEmployee : defaultPayload.employeeCallAverageRequest,
      tableCallAverageRequest: Object.keys(callTable).length ? callTable : defaultPayload.tableCallAverageRequest,
      practiceLocationRequest: Object.keys(callPracticeLocation).length ? callPracticeLocation : defaultPayload.practiceLocationRequest
    };
    dispatch(generateReport(payload));

    const body = {
      "productCallAverageRequest": callProduct,
      "employeeCallAverageRequest": callEmployee,
      "tableCallAverageRequest": callTable,
      "practiceLocationRequest": callPracticeLocation,
    }
    dispatch(userService.generateReport(body))

  };


  const onChangeCallEmployee = (newCallEmployee) => {
    setCallEmployee(newCallEmployee)

  }
  const onChangeCallProduct = (newCallProduct) => {
    setCallProduct(newCallProduct)

  }

  const onChangePracticeLocation = (newPracticeLocation) => {
    setCallPracticeLocation(newPracticeLocation)

  }
  const onChangeCallTable = (newCallTable) => {
    setCallTable(newCallTable)

  }
  const doctorColumns = [
    { label: "Name", accessor: "name" },
    { label: "Specialization", accessor: "specializationName" },
    { label: "Designation", accessor: "rankName" },
    { label: "City", accessor: "cityName" },
    { label: "Status", accessor: "status" },
  ];

  const transformedDoctors = filter_doctors?.map((doctor) => ({
    ...doctor,
    status: (
      <span
        style={{
          background: "#4361FF1A",
          width: "56px",
          height: "26px",
          padding: "3px 8px",
          display: "inline-block",
          textAlign: "center",
          lineHeight: "20px",
          borderRadius: "4px 0px 0px 0px",
          opacity: 1,
        }}
      >
        {doctor.active ? "Active" : "Inactive"}
      </span>
    ),
  }));


  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className={isLoading ? "blur-content" : ""}>
        <div>
          <div className="row align-items-center">
            <div className="col-4 mb-4">
              {/* Title */}
              <Heading6Regular text="Dashboard" color="#1E293B" />
            </div>
            {/* Actions */}
            <div className="col-8 d-flex justify-content-end align-items-center" style={{ gap: "16px" }}>
              {/* Refresh Button  */}
              <button
                onClick={handleClick}
                className="w-9 h-9 d-flex align-items-center justify-content-center rounded-xl bg-white shadow border-0 p-0"
                title="Refresh"
                style={{ minWidth: "36px", minHeight: "36px" }}
              >
                <RotateCcw size={20} />
              </button>
              <CustomButton
                text="Download Summary"
                width="180px"
                icon={Download}
                onClick={handleSummaryClick}
              />
            </div>

          </div>
          {permissions && permissions.includes("CanViewStats") && (
            <DashboardStats />
          )}

          {/* Nav */}
          <div className="row">
            <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)}>
              <Tab label="Call Average" value="Call Average" onClick={CallAverageChange} />
              <Tab label="KOL" value="KOL" onClick={KolChange} />
            </Tabs>
          </div>
        </div>
        <div>
          <div className="row">
            {showKol != true && (
              <div className="col-12 mt-5"
                style={{ width: '', height: '374px' }}
              >

                <div className="row justify-content-center mt-2">
                  {!showKol && <Linechart chartSummaryData={chartSummaryData?.data?.byEmployees} loading={chartLoading} onChangeCallEmployee={onChangeCallEmployee} />}
                </div>

                <div className="row justify-content-center mt-5">
                  {!showKol && <Barchart chartSummaryData={chartSummaryData?.data?.byProducts} loading={chartLoading} onChangeCallProduct={onChangeCallProduct} />}
                </div>

                <div className="row justify-content-center mt-5">
                  {!showKol && <StackedBarchart chartSummaryData={chartSummaryData?.data?.byPracticeLocations} loading={chartLoading} onChangePracticeLocation={onChangePracticeLocation} />}
                </div>

                <div className="row justify-content-center mt-5" >
                  {showKol != true && <Tabular onChangeCallTable={onChangeCallTable} />}
                </div>
              </div>
            )}

            {showKol == true && (
              <div className="content-wrapper">

                <div className="pagination">
                  <SearchInput
                    setText={setQuery}
                    text={query}
                    placeholder="Search"
                    onChange={(e) => setQuery(e.target.value)}
                  />
                  <div style={{ display: "flex", alignItems: "center" }}>

                    <CustomFilterSelect
                      label="Rank"
                      value={selected}
                      onChange={handleRankChange}
                      options={options}
                      isLoading={customerRank === "isLoading"}
                    />
                  </div>
                </div>
                <DynamicTable
                  data={transformedDoctors}
                  isLoading={doctors === "isLoading"}
                  columns={doctorColumns}

                />
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
